import React from 'react';
import styled from 'styled-components';
import {specialSlugs} from '../../../localizedUrls/specialSlugs';
import {
  HelpCenterPageCommonProps,
  HelpCenterSectionPageData,
} from '../../../pages/HelpCenter/types';
import {FakeGrid, QueryColumnCount} from '../../Sections/TitledGridSection';
import {
  desktopLargeMinWidth,
  mediaMinDesktopLarge,
} from '../../constants/customMedia';
import {LoadingContainer} from '../../utilityComponents/Loading/Loading';
import HelpdeskInnerPage from '../HelpdeskInnerPage/HelpdeskInnerPage';
import HelpdeskSectionBreadcrumb from '../common/HelpdeskSectionBreadcrumb';
import HelpdeskSectionListItem from './HelpdeskSectionListItem';

interface Props {
  locale: HelpCenterPageCommonProps['locale'];
  translations: HelpCenterPageCommonProps['translations'];
  sections: HelpCenterPageCommonProps['sections'];
  articles: HelpCenterSectionPageData['sectionArticles'];
  activeSection: HelpCenterSectionPageData['activeSection'];
  sectionId: HelpCenterSectionPageData['activeSectionId'];
  endpoints: HelpCenterPageCommonProps['endpoints'];
  isShowOldHelpCenterEnabled?: boolean;
}

const HelpdeskArticleGrid = styled(FakeGrid)`
  padding: 0 16px;
`;

const gridColumnConfig: QueryColumnCount[] = [
  [
    `only screen and (min-width: 0px) and (max-width: ${
      desktopLargeMinWidth - 1
    }px)`,
    1,
  ],
  [mediaMinDesktopLarge, 2],
];

const HelpdeskSectionPage: React.FC<Props> = ({
  locale,
  sections,
  translations,
  articles,
  activeSection,
  sectionId,
  endpoints,
  isShowOldHelpCenterEnabled,
}) => {
  return (
    <HelpdeskInnerPage
      locale={locale}
      selectedSectionId={sectionId}
      sections={sections}
      translations={translations}
      endpoints={endpoints}
      isShowOldHelpCenterEnabled={isShowOldHelpCenterEnabled}
    >
      {!activeSection || !articles ? (
        <LoadingContainer />
      ) : (
        <>
          <HelpdeskSectionBreadcrumb
            text={activeSection.name}
            translations={{
              ...translations.breadcrumb,
              contact_form: translations.footer.contact_form,
              contact_url: `/h/${specialSlugs(locale).contact}`,
            }}
          />
          <HelpdeskArticleGrid columnCount={gridColumnConfig} gridGap={20}>
            {articles.map(article => (
              <HelpdeskSectionListItem
                key={article.id}
                article={article}
                section={activeSection}
                translations={translations.sections}
              />
            ))}
          </HelpdeskArticleGrid>
        </>
      )}
    </HelpdeskInnerPage>
  );
};

export default HelpdeskSectionPage;
